var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#111827"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 95,
    width: 118,
    height: 65,
    rx: 5,
    fill: "#1E263B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 97,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 97,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 97,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 97,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 118,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 118,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 118,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 118,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 139,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 139,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 139,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 139,
    width: 27,
    height: 19,
    rx: 5,
    fill: "#4C5876"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.091cc7e3f58c85bb021cc292a25ab4f4.svg";
export { ForwardRef as ReactComponent };